export const PRODUCTION_APP_WEB_BASE_URL = 'https://gyming-6694a.web.app';
export const STAGING_APP_WEB_BASE_URL = 'https://gyming-staging.web.app';

export type ResolveAppWebBaseUrlInput = {
  configuredBaseUrl?: string | null;
  environment?: string | null;
  isDev?: boolean;
  locationOrigin?: string | null;
};

const trimTrailingSlash = (value: string) => value.replace(/\/$/, '');

/**
 * Resolves the public web / deep-link base URL for the current build.
 * Prefer VITE_APP_WEB_BASE_URL. Fall back to Firebase Hosting defaults for
 * known environments, then the local origin in development.
 */
export const resolveAppWebBaseUrl = ({
  configuredBaseUrl,
  environment,
  isDev = false,
  locationOrigin,
}: ResolveAppWebBaseUrlInput = {}): string => {
  const configured = configuredBaseUrl?.trim();
  if (configured) return trimTrailingSlash(configured);

  const envName = environment?.trim().toLowerCase();
  if (envName === 'staging') return STAGING_APP_WEB_BASE_URL;
  if (envName === 'production' || envName === 'prod') return PRODUCTION_APP_WEB_BASE_URL;

  if (isDev) {
    const origin = locationOrigin?.trim();
    return origin ? trimTrailingSlash(origin) : 'http://localhost:8100';
  }

  return PRODUCTION_APP_WEB_BASE_URL;
};

export const getAppWebBaseUrl = (): string =>
  resolveAppWebBaseUrl({
    configuredBaseUrl: import.meta.env.VITE_APP_WEB_BASE_URL as string | undefined,
    environment: import.meta.env.VITE_ENVIRONMENT as string | undefined,
    isDev: import.meta.env.DEV,
    locationOrigin: typeof window !== 'undefined' ? window.location.origin : undefined,
  });
